import React from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';

import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import {
    selectOriginVisitorPhoneNumber,
    selectTicketOriginIsKnown,
} from 'flow/selectors/TicketsSelectors';
import { showCallDialog } from 'flow/actions/call-dialog-actions';
import { TicketKey } from 'flow/types/EntityKeys';

type Props = {
    ticketKey: TicketKey;
};

const MenuItemCallContact = ({ ticketKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const ticketPhoneNumber = useAppSelector((state) =>
        selectOriginVisitorPhoneNumber(state, ticketKey),
    );
    const originIsKnown = useAppSelector((state) =>
        selectTicketOriginIsKnown(state, ticketKey),
    );

    const handleClickCallContact = (event?: React.MouseEvent) => {
        event?.stopPropagation();
        dispatch(showCallDialog(ticketPhoneNumber));
    };

    if (!ticketPhoneNumber || !originIsKnown) {
        return null;
    }

    return (
        <MenuItem onClick={handleClickCallContact}>
            <span>{i18next.t('Tooltip.Title.Call')}</span>
        </MenuItem>
    );
};

export default MenuItemCallContact;
